<div class="d-flex justify-content-between align-items-center">
  <span class="fs-3 fw-700">Preguntas</span>
  <button class="btn btn-sm btn-primary" (click)="openNew()">Nueva pregunta</button>
</div>
<div class="modal-body mt-5">
  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <th>N°</th>
        <th>Criterio</th>
        <th class="text-center">Tipo</th>
        <th class="text-center">Periodicidad</th>
        <th class="text-center">Puntaje</th>
        <th class="text-center col-1"><i class="fas fa-cogs"></i></th>
      </tr>
    </thead>
    <tbody>
      @for(question of questions(); track question.id; let iq = $index) {
      <tr [class.text-muted]="!question.enabled" [class.fw-bold]="isParentRow(question)">
        <td>{{iq + 1}}</td>
        <td>
          {{question.title}}
          @if(question.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="question.tooltip"><i class="fas fa-circle-question"></i></button>}
          @if(!question.enabled){<span class="badge bg-secondary ms-1">Deshabilitada</span>}
        </td>
        <td class="text-center"><span class="badge bg-info">{{typeLabel(question)}}</span></td>
        <td class="text-center">
          @if (isParentRow(question)) {
          <span class="small">-</span>
          } @else {
          <span class="small">{{periodicityLabel(question.months)}}</span>
          @if (isSpecificMonths(question.months)) {
          <button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="monthNames(question.months)"><i class="fas fa-circle-question"></i></button>
          }
          }
        </td>
        <td class="text-center" [class.fw-500]="!isParentRow(question)" [class.fw-bold]="isParentRow(question)">
          @if (isParentRow(question)) {
          <span>{{getTotalScore(question)}}</span>
          } @else {
          {{question.score || 1}}
          }
        </td>
        <td class="text-end text-nowrap">
          @if(iq < questions().length - 1) {
          <button class="btn btn-xs btn-ghost" (click)="moveDown(iq)" triggers="hover" ngbTooltip="Mover abajo"><i class="fas fa-angle-down"></i></button>
          }
          @if(iq > 0) {
          <button class="btn btn-xs btn-ghost" (click)="moveUp(iq)" triggers="hover" ngbTooltip="Mover arriba"><i class="fas fa-angle-up"></i></button>
          }
          <button class="btn btn-xs btn-ghost" (click)="addSub(question)" triggers="hover" ngbTooltip="Agregar subcriterio"><i class="fas fa-arrow-turn-down"></i></button>
          <button class="btn btn-xs btn-ghost" (click)="edit(question)" triggers="hover" [ngbTooltip]="question.hasHistory ? 'Editar (nombre y tipo bloqueados)' : 'Editar'"><i class="fas fa-edit"></i></button>
          <button class="btn btn-xs btn-ghost" (click)="toggleQuestionEnabled(question)" triggers="hover" [ngbTooltip]="question.enabled ? 'Deshabilitar' : 'Habilitar'">
            <i class="fas" [class.fa-toggle-on]="question.enabled" [class.fa-toggle-off]="!question.enabled"></i>
          </button>
          @if(!question.hasHistory && question.id){
          <button class="btn btn-xs btn-ghost" (click)="confirmRemove('question', question.id, question.title)" triggers="hover" ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
          }
        </td>
      </tr>
      @for(subquestion of question.subitems; track subquestion.id) {
      <tr [class.text-muted]="!subquestion.enabled">
        <td style="padding-left: 20px; width: 35px;">{{iq + 1}}.{{$index + 1}}</td>
        <td>
          {{subquestion.title}}
          @if(subquestion.tooltip){<button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="subquestion.tooltip"><i class="fas fa-circle-question"></i></button>}
          @if(!subquestion.enabled){<span class="badge bg-secondary ms-1">Deshabilitada</span>}
        </td>
        <td class="text-center"><span class="badge bg-info">{{typeLabel(subquestion)}}</span></td>
        <td class="text-center"><span class="small">{{periodicityLabel(subquestion.months)}}</span>
          @if (isSpecificMonths(subquestion.months)) {
          <button class="btn btn-xs btn-ghost ms-1" triggers="hover" [ngbTooltip]="monthNames(subquestion.months)"><i class="fas fa-circle-question"></i></button>
          }
        </td>
        <td class="text-center fw-500">{{subquestion.score || 1}}</td>
        <td class="text-end text-nowrap">
          <button class="btn btn-xs btn-ghost" (click)="moveSubDown(question, $index)" triggers="hover" ngbTooltip="Mover abajo"><i class="fas fa-angle-down"></i></button>
          <button class="btn btn-xs btn-ghost" (click)="moveSubUp(question, $index)" triggers="hover" ngbTooltip="Mover arriba"><i class="fas fa-angle-up"></i></button>
          <button class="btn btn-xs btn-ghost" (click)="addSub(question, subquestion)" triggers="hover" [ngbTooltip]="subquestion.hasHistory ? 'Editar (nombre y tipo bloqueados)' : 'Editar'"><i class="fas fa-edit"></i></button>
          <button class="btn btn-xs btn-ghost" (click)="toggleSubQuestionEnabled(subquestion)" triggers="hover" [ngbTooltip]="subquestion.enabled ? 'Deshabilitar' : 'Habilitar'">
            <i class="fas" [class.fa-toggle-on]="subquestion.enabled" [class.fa-toggle-off]="!subquestion.enabled"></i>
          </button>
          @if(!subquestion.hasHistory){
          <button class="btn btn-xs btn-ghost" (click)="confirmRemove('subquestion', subquestion.id, subquestion.title)" triggers="hover" ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
          }
        </td>
      </tr>
      }
      }@empty {
      <tr>
        <td colspan="6" class="text-center">No hay preguntas registradas</td>
      </tr>
      }
    </tbody>
  </table>
</div>

@if (showForm()) {
<app-admin-question-form
  [question]="editingQuestion()"
  [type]="formType()"
  [selectCategoryId]="selectCategoryId()"
  [yearSelected]="yearSelected()"
  [questionSystem]="questionSystem()"
  (save)="onFormSave($event)"
  (close)="showForm.set(false)" />
}
